module.exports = __webpack_public_path__ + "static/img/29-3.6f8c667.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/29-3.jpg
// module id = tinh
// module chunks = 0